import React from 'react';
import './App.css';
import 'reset-css';
import { Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './Components/homepage';
import NavBar from './Components/navbar';
import VoiceCasting from './Components/voice-casting';
// import Services from './Components/Services';
// import Portafolio from './Components/Portafolio';
import Footer from './Footer';  
import 'bootstrap/dist/css/bootstrap.min.css'; 

function App() {
  const location = useLocation();
  const hideLayout = location.pathname === "/animation-casting";
  return (
    <>
    {!hideLayout && <NavBar />}
      <div className='App'>
      <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/animation-casting" element={<VoiceCasting />} />
          </Routes>    
      </div>
       {!hideLayout && <Footer />}    
    </>
  );
}

export default App;
